/** Capitalize the first letter of each line in multiline clinical notes. */
export function capitalizeLineStarts(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined) {
    return '';
  }

  const text = String(value).replace(/\r\n/g, '\n');
  if (!text) {
    return '';
  }

  return text.replace(/(^|\n)(\s*)([a-z])/g, (_match, lineStart, spaces, letter) => {
    return `${lineStart}${spaces}${letter.toUpperCase()}`;
  });
}

export const CLINICAL_TEXT_FIELDS = [
  'chief_complaints',
  'notes',
  'special_instructions',
  'allergies',
  'current_medications',
  'personal_family_history',
  'surgical_history',
] as const;

export type ClinicalTextField = (typeof CLINICAL_TEXT_FIELDS)[number];

export function capitalizeClinicalTextFields<T extends Record<string, unknown>>(
  target: T,
  fields: readonly ClinicalTextField[] = CLINICAL_TEXT_FIELDS,
): T {
  if (!target) {
    return target;
  }

  for (const field of fields) {
    if (field in target && target[field] != null && target[field] !== '') {
      (target as Record<string, unknown>)[field] = capitalizeLineStarts(
        target[field] as string,
      );
    }
  }

  return target;
}
